<template>
    <div class="overall-risk">
        <div class="overall-risk-header col-xs-12">
            <div class="overall-risk-letter-box col-xs-3" id="overall-risk-letter-box"
                 :style="{'background-color':'#'+files.overall_risk_bg}"
                 @mouseover="showTooltip(files.overall_risk_level_tooltip, $event)"
                 @mouseout="hideTooltip()">
                <div class="letter" style="top:3px; position: absolute;">
                    {{files.overall_risk_letter}}
                </div>
            </div>
            <div class="overall-risk-content col-xs-8">
                {{files.customer_name}} <br> Overall Threat:
                {{fixedRiskPercent}}%
                <br>
                <div class="line" style="border-bottom: 1px solid #FAFAFA; width: 142%"></div>
            </div>
            <div class="logo-and-actions col-xs-1">
                <button id="send-threat-email-partner-button" @click="send_threat_email_child(files.enterprise_id)" :disabled="is_send_threat_email_disabled">
                    <!--Send Threat Email-->
                    <img @mouseover="showTooltip('Send Threat Email', $event)"
                         @mouseout="hideTooltip()" src="../../assets/mail.png" alt="Send Threat Email" style="width: 26px; height: 18px">
                </button>
                <img id="send-threat-email-partner-indicator" src="../../assets/mail-loading.gif" style="display: none">
            </div>
        </div>
        <div class="overall-other-risk col-xs-12" v-for="file in sortedFiles">
            <div class="overall-other-risk-letter col-xs-2"
                 :style="{'background-color':'#'+file.background}"
                 @mouseover="showTooltip(file.risk_letter_tooltip, $event)"
                 @mouseout="hideTooltip()">
                <div class="letter-other-risks" v-if="file.risk_letter == '!'" style="right: 14px; position: absolute;">
                    <p>{{file.risk_letter}}</p>
                </div>
                <div class="letter-other-risks" v-if="file.risk_letter != '!'" style="right: 10px; position: absolute;">
                    <p>{{file.risk_letter}}</p>
                </div>
            </div>
            <div class="overall-other-risk-content col-xs-7">
                <div class="overall-other-risk-content-percentage col-xs-2"><p :style="{'color':'#'+file.background}">
                    {{file.percentage.toFixed()}}%</p></div>
                <div class="overall-other-risk-content-riskname col-xs-10"
                     @click.prevent="selectRiskSend(file.risk_group_header, file.risk_group_enum_no, file.percentage, file.background)">
                    <a href="" style="text-decoration: none; color: white !important;">{{file.risk_group_header}}</a>
                </div>
            </div>
            <div class="overall-other-risk-content-issues col-xs-3"
                 @click.prevent="selectRiskSend(file.risk_group_header, file.risk_group_enum_no, file.percentage, file.background)">
                <a href="" style="text-decoration: none; color: white !important;">{{file.total_issue_count}} Issues</a>
            </div>
        </div>
        <global-tooltip ref="tooltip"></global-tooltip>
    </div>
</template>

<script>
    import GlobalTooltip from '@/components/tooltip/GlobalTooltip.vue'

    export default {
        name: "overall-risk",
        comments: {},
        components: {GlobalTooltip: GlobalTooltip},
        props: {
            sortedFiles: {
                type: Array,
                required: true
            },
            files: {
                type: Object,
                required: true
            },
            is_send_threat_email_disabled: {
                type: Boolean,
                required: false
            },
            send_threat_email: {
                type: Function,
                required: false
            }
        },
        methods: {
            send_threat_email_child(enterprise_id) {
                this.$emit('send_threat_email', enterprise_id);
            },
            selectRiskSend(item, enumNo, percentage, background) {
                this.$emit('selectRisk', item, enumNo, percentage, background);
            },
            showTooltip (text, e) {
                this.$refs.tooltip.showTooltip(e.clientY + 10, e.clientX + 10, text);
            },
            hideTooltip() {
                this.$refs.tooltip.hideTooltip();
            }
        },
        computed: {
            fixedRiskPercent: function () {
                if (this.files.overall_risk_percent != null)
                    return this.files.overall_risk_percent.toFixed();
            }
        }
    }
</script>

<style scoped>
    .logo-and-actions {
        font-family: Digital-Serial-Bold;
        margin-right: 8px;
    }

    .logo-and-actions button {
        background: black;
        border: 0;
        color: white;
        font-size: 16px;
        /*margin-left: 100px;*/
        margin-top: 18px;
        margin-left: 8px;
    }
    .overall-risk-header {
        margin-bottom: 50px;
    }

    .overall-risk-letter-box {
        height: 50px;
        width: 50px;
        text-align: center;
        font-size: 32px;
        color: white;
        font-family: Titillium Web Bold;
        margin-top: 20px;
    }

    .overall-risk-content {
        font-size: 20px;
        color: white;
        font-family: Digital-Serial-Bold;
        margin-top: 15px;
    }

    .overall-other-risk {
        margin-bottom: 20px;
        margin-left: 35px;
    }

    .overall-other-risk-letter {
        height: 35px;
        width: 35px;
        color: white;
        font-family: Titillium Web Bold;
        font-size: 25px;
        text-align: center;
    }

    .overall-other-risk-content {
        font-family: Digital-Serial-Bold;
    }

    .overall-other-risk-content-percentage {
        margin-top: 7px;
        font-size: 16px;
    }

    .overall-other-risk-content-riskname {
        font-size: 13px;
        color: white;
        margin-top: 9px;
    }

    .overall-other-risk-content-issues {
        font-size: 13px;
        color: white;
        margin-top: 9px;
        text-align: right;
        font-family: Digital-Serial-Bold
    }
</style>



// WEBPACK FOOTER //
// src/components/risk-score/OverallRisk.vue